var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiMyAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM3.5 3.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zM5 8a1.5 1.5 0 00-1.5 1.5v1a.5.5 0 01-1 0v-1A2.5 2.5 0 015 7h2a2.5 2.5 0 012.5 2.5v1a.5.5 0 01-1 0v-1A1.5 1.5 0 007 8H5z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--my-account-7caa7202678c1d93be9bb14a7837221c.svg";
export { SvgIconUiMyAccount as Component };